import React, { useState } from 'react';
import { Spacer, Text, Seperator } from 'components/atoms';
import PropTypes from 'prop-types';
import ReactJson from 'react-json-view'
import { useDebounce } from 'react-use'
import styled from 'styled-components/macro'
import { Authenticator } from 'containers'

const JsonEditor = ({ initialProps, onChange }) => {
  const [editorProps, setEditorProps] = useState(initialProps)

  const handleChange = ({ updated_src: newSrc, name }) => {
    // don't allow editing the name key
    if (name !== 'name') setEditorProps(newSrc)
  }

  useDebounce(() => {
    onChange(editorProps);
  }, 200,
  [editorProps]
  )

  return (
    <Wrapper>
      <Authenticator requires="admin">
        <Spacer top="l" bottom="l">
          <Seperator />
        </Spacer>
        <Text modifiers={['base']}>Edição de JSON:</Text>
        <Spacer top="xs2" />
        <Text modifiers={['xs']}>
          Este formato de edição é apenas visível para administradores.
        </Text>
        <Spacer bottom="l" />
        <ReactJson
          src={initialProps}
          onAdd={handleChange}
          onEdit={handleChange}
          onDelete={handleChange}
          iconStyle="circle"
          displayDataTypes={false}
          collapsed={2}
          name={null}
        />
      </Authenticator>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  font-size: 15px;
  .react-json-view {
    background-color: ${props => props.theme.colors.bgLighterS} !important;
  }

  .object-key {
    color: ${props => props.theme.colors.base} !imporant;
    font-weight: ${props => props.theme.weight.base} !imporant;
  }
`

JsonEditor.propTypes = {
  onChange: PropTypes.func.isRequired,
  initialProps: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
};

export default JsonEditor;
